import { useEffect, useState } from "react"

import { App, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router"

import { authErrorReset } from "../../LoginPage/redux/auth.actions"
import { verifyAdminInviteToken } from "../../LoginPage/services"

const { Text } = Typography

const getInviteErrorMessage = (response, t) =>
  response?.data?.message?.detail ||
  response?.data?.message ||
  response?.data?.detail ||
  response?.message?.detail ||
  response?.message ||
  t("Something went wrong, kindly try again")

const showInviteError = (notification, message, t) => {
  notification.error({
    description: message,
    closeIcon: <Text>{t("Dismiss")}</Text>
  })
}

export const useAdminAcceptInvitePage = () => {
  const { t } = useTranslation()
  const { notification } = App.useApp()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { token } = useParams()
  const [verifying, setVerifying] = useState(true)

  useEffect(() => {
    document.title = "Admin Accept Invite - Chargeback"
    dispatch(authErrorReset())
  }, [dispatch])

  useEffect(() => {
    let isMounted = true

    const verifyInvite = async () => {
      if (!token) {
        navigate("/login", { replace: true })
        return
      }

      try {
        const response = await verifyAdminInviteToken({ token })

        if (!isMounted) return

        if (response?.ok) {
          setVerifying(false)
          return
        }

        showInviteError(notification, getInviteErrorMessage(response, t), t)
        navigate("/login", { replace: true })
      } catch (requestError) {
        if (!isMounted) return

        showInviteError(notification, getInviteErrorMessage(requestError, t), t)
        navigate("/login", { replace: true })
      }
    }

    verifyInvite()

    return () => {
      isMounted = false
    }
  }, [navigate, notification, t, token])

  return {
    token,
    verifying
  }
}
